import * as ambassadorWixAnalyticsSemanticModelV3SemanticModel from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.http.js';
import * as ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.types.js';
import * as ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function querySemanticModelData(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.QuerySemanticModelDataRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.QuerySemanticModelDataRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.QuerySemanticModelDataResponse,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.QuerySemanticModelDataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAnalyticsSemanticModelV3SemanticModel.querySemanticModelData(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/semantic-models/query-data',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSemanticModel(): __PublicMethodMetaInfo<
  'GET',
  { semanticModelId: string },
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.GetSemanticModelRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.GetSemanticModelRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.GetSemanticModelResponse,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.GetSemanticModelResponse
> {
  const payload = { semanticModelId: ':semanticModelId' } as any;

  const getRequestOptions =
    ambassadorWixAnalyticsSemanticModelV3SemanticModel.getSemanticModel(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/semantic-models/{semanticModelId}',
    pathParams: { semanticModelId: 'semanticModelId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listSemanticModels(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.ListSemanticModelsRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.ListSemanticModelsRequest,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelUniversalTypes.ListSemanticModelsResponse,
  ambassadorWixAnalyticsSemanticModelV3SemanticModelTypes.ListSemanticModelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAnalyticsSemanticModelV3SemanticModel.listSemanticModels(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/semantic-models',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SemanticModel as SemanticModelOriginal,
  FilterPrefixEnum as FilterPrefixEnumOriginal,
  FilterPrefixEnumWithLiterals as FilterPrefixEnumWithLiteralsOriginal,
  FilterConditionEnum as FilterConditionEnumOriginal,
  FilterConditionEnumWithLiterals as FilterConditionEnumWithLiteralsOriginal,
  FieldValue as FieldValueOriginal,
  FieldValueValueOneOf as FieldValueValueOneOfOriginal,
  FieldTypeEnum as FieldTypeEnumOriginal,
  FieldTypeEnumWithLiterals as FieldTypeEnumWithLiteralsOriginal,
  FieldFilters as FieldFiltersOriginal,
  Field as FieldOriginal,
  QuerySemanticModelDataRequest as QuerySemanticModelDataRequestOriginal,
  DateTimeInterval as DateTimeIntervalOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  FieldFilter as FieldFilterOriginal,
  Paging as PagingOriginal,
  QuerySemanticModelDataResponse as QuerySemanticModelDataResponseOriginal,
  DataRow as DataRowOriginal,
  PagingMetadata as PagingMetadataOriginal,
  GetSemanticModelRequest as GetSemanticModelRequestOriginal,
  GetSemanticModelResponse as GetSemanticModelResponseOriginal,
  ListSemanticModelsRequest as ListSemanticModelsRequestOriginal,
  ListSemanticModelsResponse as ListSemanticModelsResponseOriginal,
  QuerySemanticModelDataApplicationErrors as QuerySemanticModelDataApplicationErrorsOriginal,
  GetSemanticModelApplicationErrors as GetSemanticModelApplicationErrorsOriginal,
  ListSemanticModelsApplicationErrors as ListSemanticModelsApplicationErrorsOriginal,
} from './analytics-semantic-model-v3-semantic-model-analytics-semantic-model.types.js';
